import { Injectable } from '@angular/core';
import { HttpUtils } from '../../http/HttpUtils';
import { CheckSubscriptionApiResponse } from './Response/CheckSubscriptionApiResponse';

@Injectable({
    providedIn: 'root'
})

export class CheckSubscriptionApi
{
    private apiUrl = '/api/subscription/check';

    public async Get(subscriptionId: string): Promise<boolean>
    {
        const apiUrl = `${this.apiUrl}?subscriptionId=${subscriptionId}`;

        const response = await fetch(apiUrl);

        await HttpUtils.ProcessFetchResultAsync(response);

        const responseObject = await response.json() as CheckSubscriptionApiResponse;

        return responseObject.IsActive;
    }
}
